const mainRu = {
  projectText: 'Проект трансформации сознания',
  heroChoose: 'Выбери своё действие, которое изменит тебя и весь мир!',
  heroButton1: 'Перейти к услугам',
  heroButton2: 'Калькулятор матрицы',
  projectAuthor: 'Автор проекта',
  authroDesc:
    '<0>Дарина Дупак — </0>профессиональный инициированный консультант по предназначению, диагностике и коррекции судьбы',
  aboutAuthorWork1: 'Дипломированный менеджер социокультурной деятельности',
  aboutAuthorWork2:
    'Работаю над созданием личностных брендов, провожу трансформационные ивенты.',
  aboutAuthorWork3:
    'Работаю по авторскому методу Наталии Ладини, известного как Матрица Судьбы',
  aboutAuthorWork4:
    'Владею углублёнными расчётами метода и техниками исцеления.',
  aboutAuthorWork5:
    'Получила магистерскую степень по психологии в Таврическом национальном университете имени В. И. Вернадского',
  aboutAuthorWork6:
    'Изучаю кармический менеджмент и причинно-следственные связи в Институте Азиатской Классики',
  aboutKarmaTitle: 'Что такое карма и как она работает?',
  aboutKarmaDesc1: 'Учениям о карме более 2,5 тыс. лет',
  aboutKarmaDesc2:
    '“Карма” с санскрита переводится, как «действие, деятельность»',
  aboutKarmaNearHands:
    'Мысли, слова, поступки - это всё действия, которые мы совершаем ежедневно.',
  aboutKarmaTextUnderContainer:
    'Каждое из них всегда несёт за собой определённое последствие или результат. Эти результаты формируют наш дальнейший путь и судьбу.',
  aboutKarmaResultText: 'Всё дает свои плоды!',
  whatIsMatrixTitle1: 'Что такое',
  whatIsMatrixTitle2: 'Матрица Судьбы?',
  whatIsMatrixMatrixCreator:
    'Авторский метод Наталии Ладини, которому более 16 лет.',
  whatIsMatrixAboutMethod:
    'Этот метод фактически является зеркалом вашей кармы и уникальным инструментом для диагностики предназначения и исцеления души, разума и тела.',
  whatIsMatrixLinkToCalculator: 'Расчитать свою матрицу бесплатно',
  matrixMinusAndPlusTitle1: 'Матрица в минусе',
  matrixMinusAndPlusTitle2: 'Матрица в плюсе',
  matrixMinusAndPlusCheckboxText: 'Проработать матрицу',
  matrxiMinusPuzzle: 'испытываешь финансовые трудности',
  waysToTransformationTitle: 'Я проведу тебя к истинным желаниям твоей души',
  waysToTransformationAbout:
    'Ты не останешься один с багажом новой информации о себе - так как я гарантирую:',
  waysToTransformationWarning:
    '*Беспечное вскрытие судьбоносных программ, без готовности работать над ними, чревато последствиями. Поэтому для вашей безопасности и блага все полноценные разборы матрицы НЕ проводятся без готовности идти в трансформацию.',
  waysToTransformationConsultationTitle: 'На Консультации',
  waysToTransformationConsultationText1:
    'Индивидуальный подход к каждой душе и её жизненным проблемам',
  waysToTransformationConsultationText2:
    'Уникальные трактовки соединений энергий в твоей матрице',
  waysToTransformationConsultationText3:
    'Информацию, которая со временем раскроется в новом, глубинном ключе',
  waysToTransformationTransformationWayTitle: 'На Трансформации',
  waysToTransformationTransformationWayText1:
    'Энергетическую и информационную поддержку.',
  waysToTransformationTransformationWayText2:
    'Предоставление комплекса рекомендаций и материалов - кармический рецепт',
  waysToTransformationTransformationWayText3:
    'Разноплановые методики и практики для проработки',
  waysToTransformationTransformationWayText4:
    'Отслеживание процесса трансформации с помощью точек контроля между этапами в формате созвонов.',
  ServicesAndPriceTitle: 'Услуги и прайс',
  ServicesAndPriceFourStages: 'Глубинные проработки: 4 уровня матрицы',
  ServicesAndPriceWarning: '*Каждый уровень прорабатывается последовательно',
  ServicesAndPriceDetail: 'Подробнее',
  ServicesAndPriceConsultationsIndividualRequest:
    'Также вы можете разобрать проблему по индивидуальному запросу',
  ServicesAndPriceConsultationsTitle: 'Консультации',
  ServicesAndPriceExpressServicesTitle: 'Экспресс-услуги',
  ServicesAndPriceExpressServicesAdditionalInfo1:
    'Также вы можете подарить своим близким',
  ServicesAndPriceExpressServicesAdditionalInfo2: 'на любую услугу.',
  ServicesAndPriceExpressServicesCert: 'сертификат',
  masterClassTitle: 'Авторские <1>мастер-классы</1>',
  cost: 'Стоимость:',
  feedback: 'Отзывы',
  feedbackDesc:
    'Я буду рада стать твоим проводником в новом этапе твоей жизни!',
  calculate: 'Рассчитай',
  yourMatrix: 'свою Матрицу Судьбы',
  aboutCalc:
    'Продвинутый бесплатный калькулятор для быстрого и профессионального расчета',
  infoAboutCalc:
    '* Калькулятор на 100% соответствует классическим расчётам метода «Матрица Судьбы» Наталии Ладини',
  calcBtn: 'Рассчитать',
  freeRecommendationTitle: 'Бесплатно делюсь полезностями в соц. сетях:',
  peopleAsk: 'Меня часто спрашивают',
  FourLevels: '4 уровня матрицы',
  aboutMethods: 'О методе Матрицы',
  policy: 'Политика конфиденциальности',
  designedBy: 'Дизайн сайта by shlm.anna',
};

export default mainRu;
